// Polish translations
export const pl = {
  // App
  appName: 'CarTrip',
  signIn: 'Zaloguj się',
  signUp: 'Zarejestruj się',
  signOut: 'Wyloguj się',
  email: 'E-mail',
  password: 'Hasło',
  fullName: 'Pełna Nazwa',
  
  // Navigation
  home: 'Strona Główna',
  profile: 'Profil',
  settings: 'Ustawienia',
  menu: 'Menu',
  analytics: 'Analityka',
  
  // Trips
  myTrips: 'Moje Podróże',
  newTrip: 'Nowa Podróż',
  selectTrip: 'Wybierz Podróż',
  tripName: 'Nazwa Podróży',
  createTrip: 'Utwórz Podróż',
  deleteTrip: 'Usuń Podróż',
  stops: 'przystanki',
  tripHistory: 'Historia Podróży',
  
  // Stops
  addStop: 'Dodaj Przystanek',
  editStop: 'Edytuj Przystanek',
  deleteStop: 'Usuń Przystanek',
  noStops: 'Brak przystanków',
  
  // Stop types
  city: 'Miasto',
  gasStation: 'Stacja Benzynowa',
  evCharging: 'Ładowanie EV',
  restaurant: 'Restauracja',
  hotel: 'Hotel',
  attraction: 'Atrakcja',
  parking: 'Parking',
  other: 'Inne',
  
  // Common
  cancel: 'Anuluj',
  delete: 'Usuń',
  close: 'Zamknij',
  save: 'Zapisz',
  search: 'Szukaj',
  loading: 'Ładowanie...',
}
